import PropTypes from 'prop-types';
import React from 'react';

import alphabetise from 'site-react/core/helpers/alphabetise';

import locationsLinks from '../data/locations';
import MobileNavMenu from './MobileNavMenu';

const { cities, londonAreas, popularLondonAreas } = locationsLinks;

cities.links.sort((a, b) => alphabetise(a.label, b.label));
londonAreas.links.sort((a, b) => alphabetise(a.label, b.label));
popularLondonAreas.links.sort((a, b) => alphabetise(a.label, b.label));
const locationsArray = [cities, londonAreas, popularLondonAreas];

const MobileNavGuides = ({ onNavListItemClick }) => (
  <MobileNavMenu
    links={locationsArray}
    onNavListItemClick={onNavListItemClick}
  />
);

MobileNavGuides.defaultProps = {
  onNavListItemClick: null,
};

MobileNavGuides.propTypes = {
  onNavListItemClick: PropTypes.func,
};

export default MobileNavGuides;
